import * as React from "react";
import { useContext } from "react";
const RuleBuilderContext = React.createContext(null);
const useRuleBuilder = () => {
  try {
    const context = useContext(RuleBuilderContext);
    if (!context) {
      throw new Error("useRuleBuilder must be used within a RuleBuilderProvider");
    }
    return context;
  } catch {
    return { useHighlightedOutput: ["", () => {
    }] };
  }
};
export { useRuleBuilder };
export default RuleBuilderContext;
